import React from "react";
import {
  LuSun,
  LuLeaf,
  LuSprout,
  LuTreePine,
  LuDroplets,
  LuRecycle,
  LuGlobe,
  LuBookOpen,
  LuGraduationCap,
  LuUsers,
  LuBuilding2,
  LuZap,
  LuPlug,
  LuFactory,
  LuMonitor,
  LuCpu,
  LuBarChart3,
  LuScale,
  LuHeartPulse,
  LuShieldCheck,
  LuWind,
  LuFlaskConical,
  LuTarget,
  LuBus,
  LuWheat,
  LuLightbulb,
} from "react-icons/lu";

/* Ajratilgan kartalardagi belgilar. Kalitlar admin paneldagi
   SDGGoalSectionHighlight.ICON_CHOICES bilan bir xil bo'lishi shart. */
const ICONS = {
  sun: LuSun,
  leaf: LuLeaf,
  sprout: LuSprout,
  tree: LuTreePine,
  droplets: LuDroplets,
  recycle: LuRecycle,
  globe: LuGlobe,
  book: LuBookOpen,
  graduation: LuGraduationCap,
  users: LuUsers,
  building: LuBuilding2,
  zap: LuZap,
  plug: LuPlug,
  factory: LuFactory,
  monitor: LuMonitor,
  cpu: LuCpu,
  chart: LuBarChart3,
  scale: LuScale,
  heart: LuHeartPulse,
  shield: LuShieldCheck,
  wind: LuWind,
  flask: LuFlaskConical,
  target: LuTarget,
  bus: LuBus,
  wheat: LuWheat,
  lightbulb: LuLightbulb,
};

/** Belgi tanlanmagan yoki noma'lum bo'lsa — hech narsa chizilmaydi. */
export const HighlightIcon = ({ name, className }) => {
  const Icon = ICONS[name];
  if (!Icon) return null;
  return <Icon className={className} aria-hidden="true" />;
};

export default HighlightIcon;
